class UtpUploadsController {
    constructor($browser, UserDetailsApi, UtpUploadsService, UsersAdminServiceApi, AppServiceApi, ModalService, $uibModal, toastr, moment, Upload, SettingsService, $window, $routeParams, ReportUtils, UtpUploadsServiceApi, ProjectTestingServiceApi, ApiErrorService, ngProgressFactory, $location, ScriptInjectionService) {
        this.onSizeChange = () => {
            this.gridOptions.api.sizeColumnsToFit();
        };
        this.exportCsv = () => { };
        this.createAction = (method, popoverText, icon, spinner) => {
            const action = [
                '<button class="btn btn-xs btn-info" ',
                'ng-click="',
                method,
                '" ',
                'uib-popover="',
                popoverText,
                '" ',
                "popover-animation ",
                "popover-trigger=\"'mouseenter'\" ",
                'popover-placement="left" ',
                'popover-append-to-body="true" >',
                '<i class="',
                icon,
                '">',
                "</i>",
                spinner,
                "</button>",
            ].join(" ");
            return action;
        };
        this.nameRenderer = (upload) => {
            let uploadData = upload.data;
            const text = [
                "<span ",
                'popover-placement="right"',
                'popover-append-to-body="true"',
                'uib-popover="',
                uploadData.Description,
                ' not viewable in browser"',
                "popover-animation",
                "popover-trigger=\"'mouseenter'\"",
                ">",
                uploadData.Description,
                "</span>",
            ].join(" ");
            if (uploadData.XmlContentType == null ||
                uploadData.XmlContentType === "application") {
                return text;
            }
            const link = [
                '<a ng-href=""',
                'class="space-top pointer"',
                'ng-click="vm.showUpload(data)"',
                'uib-popover="',
                uploadData.Description,
                ' - Click to View"',
                'popover-placement="right"',
                'popover-append-to-body="true"',
                "popover-animation popover-trigger=\"'mouseenter'\"",
                ">",
                uploadData.Description,
                "</a>",
            ].join(" ");
            return link;
        };
        this.timeCellRenderer = (params) => {
            const time = [
                '<span  uib-popover="',
                this.moment(new Date(params.data.Created))
                    .subtract(this.userDetails.TimezoneOffset, "m")
                    .format(this.state.DateFormats.DateTimeFormat),
                '" popover-placement="right" popover-append-to-body="true" popover-animation popover-trigger="\'mouseenter\'" >',
                this.getFromNowString(new Date(params.data.Created)), //  moment(new Date(params.data.Created)).format(vm.state.DateFormats.DateTimeFormat),
                "</span>",
            ].join("");
            return time;
        };
        this.showError = (errorText) => {
            this.toastr.error(errorText, "", {
                closeButton: true,
                timeOut: 0, // It open until user dismisses it manually
                extendedTimeOut: 0, // Keeps it open when browser window loses focus
            });
        };
        this.actionsCellRenderer = (row) => {
            let rowData = row.data;
            let version = rowData.VersionNumber.toString().trim();
            let tooltip = "Download File: " + rowData.Description + " (version " + version + ")";
            // var tooltip = 'this is a tes';
            let action = "vm.downloadUpload(data)";
            let icon = "fa fa-download";
            let download = this.createAction(action, tooltip, icon, "");
            if (!this.userDetails.IsSupport) {
                return download;
            }
            version = rowData.VersionNumber.toString().trim();
            tooltip =
                "Delete File: " + rowData.Description + " (version " + version + ")";
            action = "vm.deleteConfirmation(data)";
            icon = "glyphicon glyphicon-trash";
            let deleteUpload = this.createAction(action, tooltip, icon, "");
            return ('<div class="ag-grid-actions-container">' +
                download +
                deleteUpload +
                "</div>");
        };
        this.$onInit = () => {
            this.systemInfo = {};
            this.userDetails = {};
            this.data = {
                Users: [],
                uploadList: [],
                projectInfo: null,
            };
            this.state = {
                DateFormats: {},
                tblName: null, // Setup
                tblId: 0, // Setup
                title: "Uploads",
                selectedUser: null,
                uploading: false,
                showAll: false,
                maxUploadMb: 0,
                InvalidUploadExtensions: null,
                showSpinner: true,
                isSSO: false,
                progressText: "",
                lastDeletedId: 0,
            };
            this.columnDefs = [
                {
                    headerName: "File Name",
                    width: 380,
                    minWidth: 115,
                    field: "Description",
                    cellRenderer: this.nameRenderer,
                    sort: "asc",
                    suppressMovable: true,
                    suppressMenu: true,
                },
                {
                    headerName: "Version",
                    width: 105,
                    minWidth: 105,
                    maxWidth: 110,
                    field: "VersionNumber",
                    suppressMenu: true,
                },
                {
                    headerName: "Date",
                    width: 175,
                    minWidth: 130,
                    field: "Created",
                    cellRenderer: this.timeCellRenderer,
                    suppressMenu: true,
                },
                {
                    headerName: "User",
                    width: 75,
                    minWidth: 75,
                    field: "CreatedByName",
                    suppressMenu: true,
                },
                {
                    headerName: "Tester Reference",
                    field: "IdPEmail",
                    width: 190,
                    minWidth: 100,
                    hide: true,
                },
                {
                    headerName: "Actions",
                    width: 100,
                    maxWidth: 100,
                    minWidth: 100,
                    cellRenderer: this.actionsCellRenderer,
                    sortable: false,
                    suppressMenu: true,
                    resizable: false,
                    suppressMovable: true,
                },
            ];
            this.gridOptions = this.ReportUtils.getDefaultGridOptions(this);
            this.gridOptions.onGridReady = () => {
                this.gridOptions.api.setRowData(this.data.uploadList);
            };
            this.state.showSpinner = true;
            this.rowCount = "0";
            // if the first part of the route is 'ProjectAttachments' and the tableName route param is 'TestProjects'
            if (this.location.path().split("/")[1] === "ProjectAttachments" &&
                this.routeParams.tableName === "TestProjects") {
                this.ProjectTestingServiceApi.getProjectById(this.routeParams.tableId).then((response) => {
                    this.data.projectInfo = response.data;
                    const projectName = this.data.projectInfo && this.data.projectInfo.Name;
                    this.state.title = projectName + " Attachments";
                });
            }
            this.SettingsService.getSettings().then((response) => {
                let appSettings = response.data;
                this.state.maxUploadMb = response.data.MaxUploadMb;
                this.state.showSpinner = false;
                this.state.DateFormats = {
                    DateTimeFormat: appSettings.DateTimeFormat,
                    DateFormat: appSettings.DateFormat,
                    TimeFormat: appSettings.TimeFormat,
                };
                this.state.InvalidUploadExtensions = appSettings.InvalidUploadExtensions;
                this.state.isSSO = appSettings.UseSingleSignOn;
            });
            // NOTE: Use the following if we use ngRoute for navigation
            // this.state.tblName = $route.current.params['Table'];
            this.state.tblName = this.routeParams.tableName;
            this.state.tblId = this.routeParams.tableId;
            // TODO: DELETE SECTION when we use ngRoute
            // If params passed in then set the state variables
            // NOTE: The following depends on a couple of hidden fields injected into the MVC view
            if (!this.state.tblName) {
                if (document.getElementById("hTblName") !== null &&
                    document.getElementById("hTblName").innerHTML !== "") {
                    this.state.tblName = document.getElementById("hTblName").innerHTML;
                }
                if (document.getElementById("hTblId") !== null &&
                    document.getElementById("hTblId").innerHTML !== "") {
                    let tblId = Number(document.getElementById("hTblId").innerHTML);
                    if (!isNaN(tblId)) {
                        this.state.tblId = tblId;
                    }
                }
            }
            // END DELETE SECTION ////////////////////////////////
            this.AppServiceApi.systemInfo().then((response) => {
                this.systemInfo = response.data;
                // TODO: If web.config says no then exit
                if (!this.systemInfo.UploadModule) {
                    this.window.history.back();
                }
                // TODO: Otherwise continue initialising
                this.UserDetailsApi.get().then((UserDetailsResponse) => {
                    this.userDetails = UserDetailsResponse.data; // setup our user details
                    if (this.userDetails.IsTester ||
                        this.userDetails.IsGroupTester ||
                        this.userDetails.IsDataValidator) {
                        this.data.Users = [
                            {
                                Id: this.userDetails.Id,
                                Name: this.userDetails.Description,
                                CoreRole: this.userDetails.CoreRole,
                                Description: this.userDetails.Description,
                            },
                        ];
                        this.state.selectedUser = this.data.Users[0];
                        this.GetUploads(null, null);
                        // this.gridOptions.api.sizeColumnsToFit();
                        return;
                    }
                    this.UsersAdminServiceApi.uploadUsers(true).then((userListResponse) => {
                        this.setup(userListResponse.data, UserDetailsResponse.data);
                    }, () => {
                        // if no user details the redirect to login page
                        this.toastr.error("Cannot get uploads information.");
                        return;
                    });
                });
            });
        };
        this.setup = (userList, currentUser) => {
            this.data.Users = this.UtpUploadsService.users(userList, currentUser);
            if (this.state.tblName !== null && this.state.tblName === "AspNetUsers") {
                this.state.tblId = this.userDetails.Id;
                this.state.tblName = this.state.tblName;
            }
            this.state.selectedUser = this.data.Users[0];
            this.GetUploads(null, null);
            // this.gridOptions.api.sizeColumnsToFit();
        };
        this.onModelUpdated = () => {
            let model = this.gridOptions.api.getModel();
            let processedRows = model.getRowCount();
            this.rowCount = processedRows.toLocaleString();
            this.gridOptions.columnApi.setColumnVisible("IdPEmail", this.state.isSSO);
            // this.gridOptions.api.sizeColumnsToFit();
        };
        this.deleteConfirmation = (upload) => {
            if (this.state.lastDeletedId !== upload.Id) {
                let modalOptions = {
                    backdrop: "static",
                    actionButtonText: "OK",
                    closeButtonText: "Cancel",
                    headerText: "Delete " + upload.Description,
                    bodyText: "Are you sure you want to delete the upload " +
                        upload.Description +
                        "?",
                };
                this.ModalService.showModal({}, modalOptions).then(() => {
                    this.deleteUpload(upload);
                });
            }
        };
        this.deleteUpload = (upload) => {
            this.state.lastDeletedId = upload.Id;
            this.UtpUploadsServiceApi.deleteUpload(upload.Id).then((response) => {
                let result = response.data === true ? "" : "not";
                if (this.state.showAll) {
                    this.GetAllUploads(null, null);
                }
                else {
                    this.GetUploads(null, null);
                }
                this.showToaster(upload, result);
            });
        };
        this.goBack = () => {
            if (this.state.title !== "Uploads" &&
                Object.keys(this.data.projectInfo).length) {
                // then uploads view is used for project attachments, so go back to project testing view for the project
                this.location.path("/TestExecution/" +
                    this.data.projectInfo.UserId +
                    "/" +
                    this.data.projectInfo.SimulatorId);
            }
            else
                this.location.path("/"); // go back home if default uploads view
        };
        // reset page to original support user uploads
        this.resetPage = () => {
            this.state.selectedUser = null;
            this.state.showAll = false;
            this.$onInit();
            return;
        };
        this.downloadUpload = (upload) => {
            let url = ["api/UtpUploads/GetUploadAttachment?Id=", upload.Id].join("");
            this.window.location.href = url;
            return;
        };
        // Show uploaded file in modal popup
        this.showUpload = (upload) => {
            let uploadContent = upload;
            // Redirect to download link
            if (uploadContent.XmlContentType === "application") {
                let url = [
                    "api/UtpUploads/GetUploadAttachment?Id=",
                    uploadContent.Id,
                ].join("");
                this.window.location.href = url;
                return;
            }
            // We already have the content so show it
            if (uploadContent.Content) {
                this.open(uploadContent);
                return;
            }
            // We don't have the content so go and get it
            this.UtpUploadsServiceApi.getUploadById(uploadContent.Id).then((response) => {
                let respData = response.data;
                uploadContent.Content = respData.XmlContentType;
                uploadContent.FileContent = respData.FileContent;
                this.open(uploadContent);
            });
        };
        /// Open Upload modal to display
        this.open = (media) => {
            if (media.FileContent === null) {
                media.FileContent =
                    "This content is too big to render internally. Please download and render externally.";
                media.XmlContentType = "text";
            }
            let modalInstance = this.uibModal.open({
                animation: true,
                backdrop: "static",
                component: "utpUploadsModalController",
                windowClass: "view-media", // see site.css for settings
                resolve: {
                    media: () => {
                        return media;
                    },
                },
            });
            // TODO: We don't really need this
            modalInstance.result.then(() => { });
        };
        //////////// End View / Download  Methods ////////////
        /////////////////// Display Methods ///////////////////
        this.getFromNowString = (utcTime) => {
            let utc = this.moment.utc(utcTime);
            let local = this.moment(utc).local();
            return this.moment(local)
                .subtract(this.userDetails.TimezoneOffset, "m")
                .fromNow();
        };
        /////////////////// End Display Methods ///////////////////
        this.toggleShow = () => {
            this.state.showAll = !this.state.showAll;
            if (this.state.showAll) {
                this.GetAllUploads(null, null);
                return;
            }
            this.GetUploads(null, null);
        };
        /////////////////// User Upload Methods ///////////////////
        // GetAllUploads - Get latest uploads by type (tblName/tblId)
        this.GetUserUploads = () => {
            this.state.tblId = this.userDetails.Id;
            if (this.state.selectedUser != null &&
                Object.prototype.toString.call(this.state.selectedUser) ===
                    "[object Object]") {
                this.state.tblId = this.state.selectedUser.Id;
            }
            else {
                this.state.selectedUser = this.data.Users[0];
                this.state.tblId = this.state.selectedUser.Id;
            }
            let tblName = this.state.tblName;
            // Call GetUploads
            if (this.state.showAll) {
                this.GetAllUploads(tblName, this.state.tblId);
            }
            else {
                this.GetUploads(tblName, this.state.tblId);
            }
        };
        // GetAllUploads - Get all uploads by type (tblName/tblId)
        this.GetAllUserUploads = () => {
            if (this.state.selectedUser === null) {
                return;
            }
            let tblName = this.state.tblName;
            this.state.tblId = this.state.selectedUser.Id;
            this.GetAllUploads(tblName, this.state.selectedUser.Id);
        };
        /////////////////// End User Upload Methods ///////////////////
        /////////////////// Data Methods ///////////////////
        // GetAllUploads - Get latest uploads by type (tblName/tblId)
        this.GetUploads = (tblName, tblId) => {
            tblName = tblName === null ? this.state.tblName : tblName;
            tblId = tblId === null ? this.state.tblId : tblId;
            this.UtpUploadsServiceApi.getLatestVersionUploadsByType(tblName, tblId).then((response) => {
                this.data.uploadList = response !== null ? response.data : null;
                this.gridOptions.api.setRowData(this.data.uploadList);
                this.gridOptions.api.hideOverlay();
            });
        };
        // GetAllUploads - Get all uploads by type (tblName/tblId)
        this.GetAllUploads = (tblName, tblId) => {
            tblName = tblName === null ? this.state.tblName : tblName;
            tblId = tblId === null ? this.state.tblId : tblId;
            this.UtpUploadsServiceApi.getUploadByType(tblName, tblId).then((response) => {
                this.data.uploadList = response !== null ? response.data : null;
                this.gridOptions.api.setRowData(this.data.uploadList);
                this.gridOptions.api.hideOverlay();
            });
        };
        /////////////////// End Data Methods ///////////////////
        /////////////////// File Upload Methods ///////////////////
        // NOTE: This is the upload method
        this.uploadFiles = (files) => {
            // Clear the previous status indicators to not confuse the user
            this.state.progressText = "";
            this.toastr.clear();
            if (files.length === 0) {
                return;
            }
            let errorWithFiles = false;
            for (let file of files) {
                // NOTE: maxUploadMb is a setting in web.config
                if (file.size >= this.state.maxUploadMb * 1024 * 1024) {
                    this.showError(`${file.name} is over the maximum allowed file size of ${this.state.maxUploadMb}Mb`);
                    errorWithFiles = true;
                }
                if (!this.ValidExtension(file.name)) {
                    this.showError(`${file.name} has an invalid filetype. You cannot upload files with extension(s): ${this.state.InvalidUploadExtensions}`);
                    errorWithFiles = true;
                }
                if (this.ScriptInjectionService.isInjectedScript(file.name)) {
                    this.showError(`${file.name} contains some invalid characters.`);
                    errorWithFiles = true;
                }
            }
            if (errorWithFiles) {
                return;
            }
            // NOTE: Upload is the ng-file-upload service
            this.state.uploading = true;
            let progressBar = this.ngProgressFactory.createInstance();
            this.gridOptions.api.showLoadingOverlay();
            this.Upload.upload({
                url: "api/UtpUploads/FileUpload?tblName=" +
                    this.state.tblName +
                    "&tblId=" +
                    this.state.tblId +
                    "&userId=" +
                    this.userDetails.Id,
                data: { Files: files },
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
                },
            })
                .progress((evt) => {
                let percent = parseInt(((100.0 * evt.loaded) / evt.total).toString(), 10);
                progressBar.set(percent);
                this.state.progressText = `${percent}% of ${evt.config.data.Files.length} file(s)`;
            })
                .then((response) => {
                progressBar.complete();
                this.state.uploading = false;
                if (response.status === 200) {
                    // success
                    this.toastr.info(`${files.length} file(s) uploaded successfully`);
                    if (this.state.showAll) {
                        this.GetAllUploads(null, null);
                    }
                    else {
                        this.GetUploads(null, null);
                    }
                }
                else {
                    // failure
                    this.gridOptions.api.hideOverlay();
                    this.ApiErrorService.error(response);
                }
            })
                .catch((error) => {
                progressBar.complete();
                this.state.uploading = false;
                this.gridOptions.api.hideOverlay();
                this.ApiErrorService.error(error);
            });
        };
        // Test file
        this.ValidExtension = (fileName) => {
            // If nothing is set in invalid extensions
            if (!this.state.InvalidUploadExtensions ||
                this.state.InvalidUploadExtensions === "") {
                return true;
            }
            // Get the file extension
            let arr = fileName.split(".");
            if (arr.length === 1) {
                return true;
            }
            // Get the extension last part of split length - 1
            let extension = arr[arr.length - 1];
            let extArray = this.state.InvalidUploadExtensions.split(",");
            // Test extension is in invalid Extension list and return converse!
            for (let i = 0; i < extArray.length; i++) {
                if (extArray[i] === extension) {
                    return false;
                }
            }
            return true;
        };
        this.browser = $browser;
        this.UserDetailsApi = UserDetailsApi;
        this.UtpUploadsService = UtpUploadsService;
        this.UsersAdminServiceApi = UsersAdminServiceApi;
        this.AppServiceApi = AppServiceApi;
        this.ModalService = ModalService;
        this.uibModal = $uibModal;
        this.toastr = toastr;
        this.location = $location;
        this.moment = moment;
        this.Upload = Upload;
        this.SettingsService = SettingsService;
        this.window = $window;
        this.routeParams = $routeParams;
        this.UtpUploadsServiceApi = UtpUploadsServiceApi;
        this.ProjectTestingServiceApi = ProjectTestingServiceApi;
        this.ReportUtils = ReportUtils;
        this.ngProgressFactory = ngProgressFactory;
        this.ApiErrorService = ApiErrorService;
        this.ScriptInjectionService = ScriptInjectionService;
    }
    showToaster(upload, result) {
        this.toastr.info([
            "Upload " +
                upload.Description +
                " version " +
                upload.VersionNumber +
                " has " +
                result +
                " been deleted.",
        ].join(""));
    }
}
angular.module("app").component("utpUploadsController", {
    bindings: {},
    templateUrl: "scripts/app/partials/Upload/upload.tpl.html",
    controllerAs: "vm",
    controller: UtpUploadsController,
});
